export default __webpack_public_path__ + "static/media/icon_book_orange.dca6c022.svg";